export default __webpack_public_path__ + "static/media/Clean.7367b1b1.jpg";